import { createReducer, on } from '@ngrx/store';

import { ClientCreateUiState, ClientCreateUiStep } from '@admin/src/core/models/client-create-ui-state.interface';
import {
  getClientPackagesOptions,
  getClientPackagesOptionsFailure,
  getClientPackagesOptionsSuccess,
  setClientCreateData,
  setClientCreateUiStep,
  setClientProfileAge,
} from '@admin/store/client-create-ui/client-create-ui.actions';

const initialState: ClientCreateUiState = {
  uiStep: ClientCreateUiStep.JsonParser,
  data: null,
  clientProfileAge: null,
  packages: {
    packagesList: [],
    loadingPackages: false,
  },
};

export const clientCreateUiReducer = createReducer(
  initialState,
  on(setClientCreateUiStep, (state, { step }) => ({ ...state, uiStep: step })),
  on(setClientCreateData, (state, { data }) => ({ ...state, data })),
  on(setClientProfileAge, (state, { age }) => ({ ...state, clientProfileAge: age })),
  on(getClientPackagesOptions, state => ({ ...state, packages: { ...state.packages, loadingPackages: true } })),
  on(getClientPackagesOptionsSuccess, (state, { packages }) => ({ ...state, packages: { packagesList: packages, loadingPackages: false } })),
  on(getClientPackagesOptionsFailure, state => ({ ...state, packages: { ...state.packages, loadingPackages: false } }))
);
